// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_1xyq6KWpik9nv8NCdy311s"};